import { login as apiLogin } from '@/api/auth'

const state = {
  token: localStorage.getItem('token') || ''
}

const getters = {
  token: state => state.token,
  isAuthenticated: state => !!state.token
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  CLEAR_TOKEN(state) {
    state.token = ''
    localStorage.removeItem('token')
  }
}

const actions = {
  async login({ commit }, { password, captchaId, captchaCode }) {
    const res = await apiLogin(password, captchaId, captchaCode)
    commit('SET_TOKEN', res.data.token)
    return res
  },
  logout({ commit }) {
    commit('CLEAR_TOKEN')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
